import { BtnClasses, Button } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import type { JSX } from 'solid-js';

import { FxWorkspaceEmptyState } from './FxWorkspaceEmptyState';

export const WorkspaceEmptyReferences = (props: {
  onAddData(): void;
}): JSX.Element => (
  <FxWorkspaceEmptyState
    icon="tc-icon-folder"
    title={t('mobileMapping.fxWorkspace.emptyWorkspace.title')}
    message={t('mobileMapping.fxWorkspace.emptyWorkspace.message')}
    dataTestId="workspace-empty-references"
    content={
      <Button
        color={BtnClasses.PRIMARY}
        icon="tc-icon-content-add"
        data-testid="workspace-add-data-button"
        onClick={props.onAddData}
      >
        {t('mobileMapping.fxWorkspace.addData')}
      </Button>
    }
  />
);
